import {Card, TabProps, TabsHeader} from 'platform/components';
import {Box, HStack, VStack} from 'platform/foundation';

import {useState} from 'react';

import {AddBasketItemBody} from '@dms/api/warehouse';
import i18n from '@dms/i18n';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {ArticleUpdateJobMaterialModalListWarehouseTab} from './ArticleUpdateJobMaterialModalListWarehouseTab';

interface ArticleUpdateJobMaterialModalListProps extends RequiredTestIdProps {
  onAddItemsToBasket: (items: AddBasketItemBody) => Promise<void>;
}

export function ArticleUpdateJobMaterialModalList(props: ArticleUpdateJobMaterialModalListProps) {
  const [activeTabId, setActiveTabId] = useState(TABS_IDS.warehouseTab);

  const tabs: TabProps[] = [
    {
      id: TABS_IDS.warehouseTab,
      title: i18n.t('entity.warehouse.labels.warehouse'),
      content: (
        <ArticleUpdateJobMaterialModalListWarehouseTab
          onAddItemsToBasket={props.onAddItemsToBasket}
          data-testid={suffixTestId('tabs.warehouse', props)}
        />
      ),
    },
  ];

  const activeTabContent = tabs.find(
    (tab) => tab.id === (activeTabId ?? TABS_IDS.warehouseTab)
  )?.content;

  return (
    <VStack spacing={4} height="100%">
      <HStack justify="space-between">
        <TabsHeader
          variant="condensed"
          tabs={tabs}
          activeTabId={activeTabId}
          onChange={setActiveTabId}
          data-testid={suffixTestId('tabs', props)}
        />
      </HStack>
      <Card isFullHeight>
        <Box height="100%" flex={1}>
          {activeTabContent}
        </Box>
      </Card>
    </VStack>
  );
}

const TABS_IDS = {
  warehouseTab: 'articleUpdateJob-addMaterial-warehouseTab',
};
